import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=bda0cf9c&scoped=true"
import script from "./VirtualList.vue?vue&type=script&lang=js"
export * from "./VirtualList.vue?vue&type=script&lang=js"
import style0 from "./VirtualList.vue?vue&type=style&index=0&id=bda0cf9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda0cf9c",
  null
  
)

export default component.exports